// adapted from: https://medium.com/simply/state-management-with-react-hooks-and-context-api-at-10-lines-of-code-baf6be8302c
import React, { createContext, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';

export const StateContext = createContext();

export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);

StateProvider.propTypes = {
  children: PropTypes.node,
  reducer: PropTypes.func.isRequired,
  initialState: PropTypes.shape().isRequired,
};

StateProvider.defaultProps = {
  children: null,
};

export const useGlobalState = () => useContext(StateContext);
